import 'roboto-fontface/css/roboto/sass/roboto-fontface-regular.scss';
import '@mdi/font/css/materialdesignicons.css';
import 'animate.css/animate.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import '../styles/styles.scss';
import './plugins/vue-rx';
import './plugins/highcharts';
import App from './App.vue';
import router from './router';
import store from '../store';
import {
  appContext,
  applyBrandingCssVariables,
  applyBrandingFavicon,
  applyCustomerBranding,
  appProvides,
  initialCustomerId
} from './composition-root';
import { routeAccessOf } from '../core/auth';
import ZoomOnHover from 'vue-zoom-on-hover';
Vue.use(ZoomOnHover)

// import './plugins/sentry';
Vue.config.productionTip = false;
Vue.config.devtools = true;
applyBrandingCssVariables();
applyBrandingFavicon();

// Colores por aseguradora (`customers[id].colors`): variables CSS + tema de Vuetify.
const theme = (vuetify as any).framework.theme;
// Al arrancar: la aseguradora de la sesión guardada solo si la ruta inicial no es por token (sin parpadeo de color).
const { pathname, search, hash } = window.location;
const initialAccess = routeAccessOf(router.resolve(`${pathname}${search}${hash}`).route);
applyCustomerBranding(initialCustomerId(initialAccess), theme);

const appInstance = new Vue({
  router,
  store,
  vuetify,
  provide: appProvides,
  render: h => h(App)
}).$mount('#app');

// Después: cada vez que cambia la aseguradora de la ruta activa (o deja de haber una → colores del tenant).
appInstance.$watch(
  () => appContext.customer.customerId,
  (customerId: number | null) => applyCustomerBranding(customerId, theme)
);


